import { IUser } from '@sdk/contracts';
import { Flex } from 'antd';

import { StudentActions } from './StudentActions';
import { StudentDetail } from './StudentDetail';

type Props = {
  student: IUser;
};

export const StudentInfo: React.FC<Props> = ({ student }) => {
  return (
    <Flex gap={24}>
      <StudentDetail student={student} />
      <StudentActions student={student} />
    </Flex>
  );
};
